"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValid = function (input) {
    if (typeof input !== 'string') {
        return false;
    }
    var postalCode = input.replace(/\D/g, '');
    var containsInvalidStart = /^32|^48|^49|^99/.test(postalCode);
    return (postalCode.length === 5 &&
        postalCode > '10000' &&
        postalCode < '99000' &&
        !containsInvalidStart);
};
//# sourceMappingURL=index.js.map